import { PDFPage } from "pdf-lib";
import { CommonDrawOptions, DocumentPlaceholder, PlaceholderType } from "../types";
import { dataDraw } from "./data";
import { dateDraw } from "./date";
import { imageDraw } from "./image";
import { signatureDraw } from "./signature";
import { textDraw } from "./text";

export * from "./text";
export * from "./date";
export * from "./data";
export * from "./image";
export * from "./signature";

export const placeholderDrawMap: Record<
  PlaceholderType,
  (page: PDFPage, placeholder: DocumentPlaceholder, common: CommonDrawOptions) => void
> = {
  [PlaceholderType.Text]: textDraw,
  [PlaceholderType.Date]: dateDraw,
  [PlaceholderType.Placeholder]: dataDraw,
  [PlaceholderType.Image]: imageDraw,
  [PlaceholderType.Signature]: signatureDraw,
};
